import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course02 from "../../../course/course-02/course";
import lesson0227 from "../../../lesson/course-02/lesson-27/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "4a46fbe6-754f-4036-aa25-b4663556ca7b",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0227),
    lesson: lesson0227,
  },
];

export default lessonLinks;
